import { CompanyType } from '@/types';
import { Core, COMPANY_TYPES } from '../Core';

class CompanyTypes extends Core {
  getCompanyTypes = async () => this.get<CompanyType[]>(COMPANY_TYPES());
}

export const companyTypes = new CompanyTypes();
